import React, { useState } from "react";
import {
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
} from "reactstrap";

const HelpCard = ({
  helpItem,
  onplotClick,
  type = "default",
  searchQuery,
}) => {
  const [showModal, setShowModal] = useState(false);

  // Handle group card click (show modal)
  const handleGroupClick = () => {
    if (helpItem.isGroup) {
      setShowModal(true);
    }
  };

  // Handle sub-page click (navigate to plot)
  const handleSubPageClick = (subPage) => {
    setShowModal(false); // Close modal first
    if (onplotClick) {
      onplotClick(subPage);
    }
  };

  // Handle regular help card click
  const handleCardClick = () => {
    if (!helpItem.isGroup && onplotClick) {
      onplotClick(helpItem);
    }
  };

  // Helper function to highlight search terms (for sub-pages in modal)
  const highlightSearchTerm = (text, searchTerm) => {
    if (!searchTerm || !searchTerm.trim() || !text) return text;

    const regex = new RegExp(
      `(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
      "gi"
    );
    return text.replace(
      regex,
      '<mark style="background-color: #fef3c7; color: #92400e; padding: 0 2px; border-radius: 2px;">$1</mark>'
    );
  };
  console.log("HELPCARD CALLED WITH ", helpItem);
  // Render group card with modal
  if (helpItem.isGroup) {
    return (
      <>
        <Card
          className="h-100 position-relative overflow-hidden"
          style={{
            borderTop: "4px solid #1A6D52",
            borderLeft: "4px solid #1A6D52",
            borderRight: "4px solid #1A6D52",
            borderBottom: "1px solid #e5e7eb",
            borderRadius: "4px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            minHeight: "280px",
          }}
          onClick={handleGroupClick}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow =
              "0 4px 12px rgba(26, 109, 81, 0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          {/* Group Header - Bigger Image */}
          <div
            className="position-relative"
            style={{
              height: "200px",
              backgroundColor: "#f8f9fa",
              overflow: "hidden",
            }}
          >
            <div
              className="w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                backgroundImage: `url(${helpItem.image})`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                padding: "12px",
              }}
            />

            {/* Group Indicator Icon */}
            <div
              className="position-absolute"
              style={{
                top: "12px",
                right: "12px",
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                borderRadius: "50%",
                width: "28px",
                height: "28px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i
                className="ri-folder-open-line"
                style={{
                  fontSize: "20px",
                  color: "#1A6D52",
                }}
              ></i>
            </div>
          </div>

          {/* Group Title - Support highlighted text */}
          <div
            style={{
              background: "linear-gradient(135deg, #1A6D52 0%, #1A6D52 100%)",
              flex: 1,
            }}
          >
            <CardBody
              className="text-white d-flex flex-column justify-content-center"
              style={{
                padding: "12px",
                minHeight: "100px",
              }}
            >
              <h6
                className="fw-bold mb-1 text-white"
                style={{
                  fontSize: "14px",
                  lineHeight: "1.3",
                }}
                dangerouslySetInnerHTML={{
                  __html: helpItem.title || helpItem.title,
                }}
              />
              <p
                className="mb-1"
                style={{
                  fontSize: "11px",
                  lineHeight: "1.3",
                  color: "rgba(255, 255, 255, 0.85)",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                }}
                dangerouslySetInnerHTML={{
                  __html: helpItem.description || helpItem.description,
                }}
              />
              <small className="text-white-50" style={{ fontSize: "10px" }}>
                {helpItem.subPages?.length} help topics • Click to view
              </small>
            </CardBody>
          </div>
        </Card>

        {/* Modal for Sub-pages */}
        <Modal
          isOpen={showModal}
          toggle={() => setShowModal(!showModal)}
          size="lg"
          centered
        >
          <ModalHeader
            toggle={() => setShowModal(false)}
            className="p-3 modal-title custom-header"
            style={{ backgroundColor: "#1A6D52", position: "relative" }}
            close={
              <button
                className="close"
                onClick={() => setShowModal(false)}
                type="button"
                style={{
                  background: "none",
                  color: "white",
                  border: "none",
                  position: "absolute",
                  right: "15px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  padding: "0",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="ri-close-line" style={{ fontSize: "20px" }}></i>
              </button>
            }
          >
            <div style={{ paddingRight: "40px" }}>
              <h5
                className="mt-0 mb-0"
                style={{ color: "white" }}
                dangerouslySetInnerHTML={{
                  __html: helpItem.title || helpItem.title,
                }}
              />
            </div>
          </ModalHeader>

          <ModalBody style={{ padding: "24px" }}>
            <p
              className="text-muted mb-4"
              style={{ fontSize: "14px" }}
              dangerouslySetInnerHTML={{
                __html: helpItem.description || helpItem.description,
              }}
            />

            <Row>
              {helpItem.subPages?.map((subPage) => (
                <Col md={6} key={subPage.id} className="mb-3">
                  <Card
                    className="h-100 position-relative overflow-hidden"
                    style={{
                      borderTop: "3px solid #1A6D52",
                      borderLeft: "3px solid #1A6D52",
                      borderRight: "3px solid #1A6D52",
                      borderBottom: "3px solid #1A6D52",
                      borderRadius: "4px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    onClick={() => handleSubPageClick(subPage)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(26, 109, 81, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <CardBody className="p-3">
                      <div className="d-flex align-items-start">
                        {/* Sub-page Image */}
                        <div
                          className="flex-shrink-0 me-3"
                          style={{
                            width: "50px",
                            height: "50px",
                            backgroundImage: `url(${subPage.image})`,
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "4px",
                          }}
                        />

                        {/* Sub-page Content - With highlighting */}
                        <div className="flex-grow-1">
                          <h6
                            className="fw-bold mb-1"
                            style={{
                              fontSize: "13px",
                              color: "#374151",
                              lineHeight: "1.3",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: highlightSearchTerm(
                                subPage.title,
                                searchQuery
                              ),
                            }}
                          />
                          <p
                            className="mb-0 text-muted"
                            style={{
                              fontSize: "11px",
                              lineHeight: "1.3",
                              overflow: "hidden",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: highlightSearchTerm(
                                subPage.description,
                                searchQuery
                              ),
                            }}
                          />
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </ModalBody>
        </Modal>
      </>
    );
  }

  // Render regular help card
  return (
    <Card
      className="h-100 position-relative overflow-hidden"
      style={{
        borderTop: "4px solid #1A6D52",
        borderLeft: "4px solid #1A6D52",
        borderRight: "4px solid #1A6D52",
        borderBottom: "1px solid #e5e7eb",
        borderRadius: "6px",
        cursor: "pointer",
        transition: "all 0.3s ease",
        minHeight: "280px",
      }}
      onClick={handleCardClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(26, 109, 81, 0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Top Section with Chart/Image - Bigger */}
      <div
        className="position-relative"
        style={{
          height: "200px",
          backgroundColor: "#f8f9fa",
          overflow: "hidden",
        }}
      >
        <div
          className="w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url("${helpItem.image}")`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />

        {/* Add play button overlay if this is the help video section */}
        {helpItem.id === "help-video" && (
          <div
            className="position-absolute d-flex align-items-center justify-content-center"
            style={{
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "150px",
              height: "150px",
              backgroundColor: "#1A6D52",
              borderRadius: "50%",
              zIndex: 10,
            }}
          >
            <i
              className="ri-play-fill text-white"
              style={{ fontSize: "50px", marginLeft: "2px" }}
            ></i>
          </div>
        )}

        {/* External Link Icon */}
        <div
          className="position-absolute"
          style={{
            top: "12px",
            right: "12px",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            borderRadius: "50%",
            width: "28px",
            height: "28px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <i
            className="ri-external-link-line"
            style={{
              fontSize: "20px",
              color: "#1A6D52",
            }}
          ></i>
        </div>
      </div>

      {/* Bottom Section with Green Background - Support highlighted text */}
      <div
        style={{
          background: "linear-gradient(135deg, #1A6D52 0%, #1A6D52 100%)",
          flex: 1,
        }}
      >
        <CardBody
          className="text-white d-flex flex-column justify-content-center"
          style={{
            padding: "12px",
            minHeight: "100px",
          }}
        >
          <h6
            className="fw-bold mb-1 text-white"
            style={{
              fontSize: "14px",
              lineHeight: "1.3",
            }}
            dangerouslySetInnerHTML={{
              __html: helpItem.title || helpItem.title,
            }}
          />
          <p
            className="mb-0"
            style={{
              fontSize: "11px",
              lineHeight: "1.3",
              color: "rgba(255, 255, 255, 0.85)",
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
            dangerouslySetInnerHTML={{
              __html: helpItem.description || helpItem.description,
            }}
          />
        </CardBody>
      </div>
    </Card>
  );
};

export default HelpCard;
